import { Box, Flex, Text } from "../../../../../../mads";
import { useI18n } from "../../../../../../shared/I18n";
import { IndeedProIcon } from "../../../lib/IndeedProIcon";

import { spacing } from "@indeed/ifl-tokens/react-native";
import React from "react";

export function ProInsightsHeader(): React.JSX.Element {
  const gt = useI18n();

  return (
    <Box sx={{ marginTop: spacing.s2 }}>
      <Flex
        sx={{
          flexDirection: "row",
          gap: spacing.s2,
          alignItems: "center",
        }}
      >
        <IndeedProIcon width={20} height={20} />
        <Text level={1} variant="contrast" sx={{ fontWeight: "bold", fontSize: 18 }}>
          {gt.gettext("Pro insights")}
        </Text>
      </Flex>
    </Box>
  );
}
